import FaqAccordian from "../home_page/FaqAccordian";

const Faq = () => {
  return <FaqAccordian />;
};

export default Faq;
